import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration';
import utc from 'dayjs/plugin/utc';
import { Label } from 'reactstrap';
const measurements = [{ name: "days", suffix: 'd' }, { name: "hours", suffix: '' }, { name: "minutes", suffix: '' }, { name: "seconds", suffix: '' }];
const withPadding = (duration) => {
    return measurements.map((m) => { return { d: duration[m.name](), m } }).map((n) => ('0' + Math.abs(n.d)).slice(-2) + n.m.suffix).join(':')
}

dayjs.extend(duration);
dayjs.extend(utc);

const GetRemaining = ({ charter,fontSize }) => {
   
    const getDuration = (charter) => {
        const durat = charter?.request?.biddingEndsAt ?
            dayjs.duration(dayjs.utc(charter?.request?.biddingEndsAt).diff(dayjs())) :
            dayjs.duration(dayjs.utc(charter?.request?.createdAt).add(charter?.request?.biddingTimeSpanHours, 'hours').diff(dayjs()));
        const wp = withPadding(durat);
        return wp;
    }
    const [timeRemaining, setTimeRemaining] = useState(getDuration(charter));
    
    useEffect(() => {
        let closed = false;
        const timeout = setTimeout(() => {
            if (!closed) {
                setTimeRemaining(getDuration(charter));
            };

            
        }, 1000);
        return () => {
            closed = true;
            clearTimeout(timeout);
        }
    })
    return <Label style={{ fontSize: fontSize, paddingRight:'15px'}}> { timeRemaining }</Label>
}

export default GetRemaining; 